import "~/misc/common";
import { getUrlParameter } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { initMapLayered } from "./map_layered";
import { initInfoObjects } from "./info_objects";
import { initLaunchPlaces } from "./launch_places";
import { initNature } from "./nature";
import { initPosition } from "./position";

export default class extends Controller {
  connect() {
    console.log('map.ts');
    $('body').css('height', '100%');
    $('html').css('height', '100%');
    $('.full-map-header>nav').css('margin-bottom', '0px');
    $(".select2.select2-container").css('width', '100%');

    const map = initMapLayered();
    //initAirspaces(map);
    initInfoObjects(map);
    initLaunchPlaces(map);
    initNature(map);
    initPosition(map);

    const url_id = getUrlParameter('launch_area_id');
    if (url_id && typeof url_id === 'string') {
      map.flyToBounds(map.launchAreas[parseInt(url_id)].getBounds(), {
        duration: 0.5
      });
    }
  }
}
